// extracted by mini-css-extract-plugin
export default {"container":"CompanyFiledsDetalis_container__P48Zv","tableCard":"CompanyFiledsDetalis_tableCard__Enxb4","showCurrency":"CompanyFiledsDetalis_showCurrency__kIKdP"};